<template>
  <div>
    <p v-if="label" class="text-sm font-semibold text-argus-forest-300 mb-2">{{ label }}</p>
    <div class="flex flex-wrap gap-2">
      <button
        v-for="opt in options"
        :key="opt.value"
        type="button"
        class="px-4 py-1.5 rounded-md text-sm font-semibold border transition-colors"
        :class="isActive(opt.value)
          ? 'bg-argus-forest-100 text-argus-forest-950 border-transparent'
          : 'bg-white/10 text-argus-forest-100 border-transparent opacity-70 hover:opacity-90'"
        @click="select(opt)"
      >
        {{ opt.label }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    label: { type: String, default: '' },
    options: { type: Array, required: true },
    modelValue: { default: null },
  },
  emits: ['update:modelValue'],
  methods: {
    isActive(v) {
      return this.modelValue === v
    },
    select(opt) {
      this.$emit('update:modelValue', opt.value)
    },
  },
}
</script>